import React from "react"
import { useTranslation } from "react-i18next"

import Button from "components/Button"
import classes from "./FuwFooter.module.scss"

const FuwFooter = props => {
  const { setTab, numberOfFiles } = props

  const [t] = useTranslation()

  const handleShowFiles = () => {
    setTab("files")
  }

  return (
    <div className={classes["footer"]}>
      <span className={classes["text"]}>
        {t("فایل_های_انتخاب_شده")}:{" "}
        {numberOfFiles}
      </span>

      <Button
        onClick={handleShowFiles}
      >
        {t("مشاهده_یا_ویرایش_فایل_ها")}
      </Button>
    </div>
  )
}

export default FuwFooter